const Page = {
  signIn: '/sign-in',
  signUp: '/sign-up',
  signUpSent: '/sign-up-sent',
  signUpConfirm: '/sign-up-confirm',
  forgotPassword: '/forgot-password',
  forgotPasswordSent: '/forgot-password-sent',
  newPassword: '/new-password',
  passwordUpdated: '/password-updated',
} as const;

export default Page;
